import { render, staticRenderFns } from "./PutOn.vue?vue&type=template&id=85d5c678&scoped=true&"
import script from "./PutOn.vue?vue&type=script&lang=js&"
export * from "./PutOn.vue?vue&type=script&lang=js&"
import style0 from "./PutOn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PutOn.vue?vue&type=style&index=1&id=85d5c678&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d5c678",
  null
  
)

export default component.exports